import SearchByType from "./search-by-type";

export default SearchByType;